import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { VideosImplementation } from '@commoncore/implementation/VideosImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';


export class VideosController{
    public videosImplementation:any;
    public fileOperationsImplementation:any;
    public universalService:any;
    public listService:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null;
    public sortOrder:any;
    loggerService: any;
    lazyLoadImgService:any;
    sessionStorageService;any;
    constructor(private globalService:GlobalService) {
    this.videosImplementation= VideosImplementation.getInstance(this.globalService);
    this.fileOperationsImplementation = FileOperationsImplementation.getInstance(this.globalService);
    }
    
    public static getInstance(globalService):VideosController{
		if(this.singleInstance == null){
			this.singleInstance = new VideosController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
      this.universalService = globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef();
      this.listService = globalService.getListServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
      if(this.universalService.virtualGridEnabled){
        this.lazyLoadImgService = globalService.getVirtualLazyLoadImgServiceRef();
      }
      this.sessionStorageService = globalService.getSessionStorageSvcRef();
    }


    getVideos(){
        //this.universalService.showSortButtons = false;
        if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
          this.universalService.nameSort = false;
          this.sortOrder="&sort=%2DfileCreatedDate";
        } else if (localStorage.sharePublicSort == this.universalService.sharePublicSortByUploadDate) {
          this.universalService.nameSort = false;
          //this.sortOrder=this.listService.listViewSortOrder;
          this.sortOrder='&sort=%2DcreatedDate';
        } else {
          this.universalService.nameSort = true;
          this.sortOrder='&sort=%2BobjectName';
        }

        if (localStorage.sharePublicSort == undefined) {
          this.universalService.nameSort = false;
          this.sortOrder="&sort=%2DfileCreatedDate";
        }else if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
          this.universalService.nameSort = false;
          this.sortOrder="&sort="+localStorage.sharePublicSort;
        } else if (localStorage.sharePublicSort == this.universalService.sharePublicSortByUploadDate) {
          this.universalService.nameSort = false;
          this.sortOrder="&sort="+localStorage.sharePublicSort;
        } else if(!this.universalService.isMobileDevice){
          this.universalService.nameSort = false;
          this.sortOrder="&sort="+localStorage.sharePublicSort;
        } else {
          this.universalService.nameSort = false;
          if(localStorage.sharePublicSort.includes("objectName"))
            this.universalService.nameSort = true;
          this.sortOrder="&sort="+localStorage.sharePublicSort;
        }
        let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
        var  videosUrl="";
        if(this.universalService.sharingAlbumFiles){
          videosUrl =  ENV_CONFIG.commonUrls["shareURL"] + this.universalService.shareKey + '?filterCode=video'; 
        } 
        // else if(this.sortOrder.includes('createdDate')) {
        //   videosUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsRecentUpload"] + "?limit=" + limit + "&filterCode=video" + this.sortOrder;   
        // }
        else {
          videosUrl= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsMetadataMimeTypeFilter"] + "?limit=" + limit +  "&filterCode=video" + this.sortOrder; 
        }
        this.videosImplementation.setHandler(this.globalService);
        try{
            this.videosImplementation.decideSortOrder(videosUrl);
        }catch(exc){
            this.loggerService.log("exception handled for videos tab");
        }
    }


    onScrollDown(docheignt,toppos){
        let self = this;
        if(!this.universalService.virtualGridEnabled){
          self.lazyLoadImgService.isScrollingStopped();
        }
        var url = "";
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  self.videosImplementation.videosnextLink;
        try{
          self.videosImplementation.createUrlForNextLink(docheignt,toppos,url);
        }
        catch(exc){
          self.loggerService.log("exception in scroll down")
        }
    }



    async updateUIAfterPerformingAction(list,executedTask){
      var array = [];
      if(!this.universalService.nameSort){
        array = this.videosImplementation.sortedVideos;
      }else{
        array = this.universalService.sortByNameArray;
      }
      if(executedTask == 'TRASH' || executedTask == "MOVE"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          if(executedTask == "MOVE" && this.universalService.selectedFolder.objectName == 'Private Folder')
            executedTask = "MOVETOPF"
          if(executedTask == 'TRASH' || executedTask == "MOVETOPF"){
            var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
            array = result;
            if(array.length == 0){
              this.getVideos();
            }else{
              if(this.universalService.virtualGridEnabled){
                AppEvents.virtualDOMObservable.next({"updateVDOM":true,"removeObjects":true,objectsList:list})
              }
            }
          }else{
            this.listService.deSelectAll(null);

          }
      }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
          array = result
          if(this.universalService.virtualGridEnabled){
            let updatedList = this.fileOperationsImplementation.returnTheListOfUpdatedObjectsForVirtualGrid(list,array);
            AppEvents.virtualDOMObservable.next({"updateVDOM":true,"updateObjects":true,objectsList:updatedList})
          }
      }else{
          this.loggerService.log("task invalid",executedTask)
      }
      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
  }

  openPublicSort(sortType,reverseOrder) {
      
    this.universalService.disableModalBackdrop();
    let sortTypeName = this.universalService.togglePublicSort(sortType,reverseOrder);
    if(sortTypeName!=""){
          this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
    }
    //this.allFilesImplementation.allFilespreviousLink = "";
    this.getVideos();
    this.universalService.isMobileTopMoreOptionMenu = false;
    this.universalService.sharePublicSortByUploadDate = "";
  }

}


